import { announcementBannerHeight } from '@/constants'
import useAnnouncement from '@hooks/useAnnouncement'
import { Box, Typography } from '@mui/material'

export default function AnnouncementBanner() {
	const message = useAnnouncement()

	if (!message) return null

	return <AnnouncementBannerUI message={message} />
}

type UIProps = {
	message: string
}

export function AnnouncementBannerUI({ message }: UIProps) {
	if (!message) return null

	return (
		<Box
			sx={{
				position: 'fixed',
				top: 0,
				left: 0,
				width: '100%',
				height: announcementBannerHeight,
				backgroundColor: 'warning.dark',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				zIndex: (theme) => theme.zIndex.appBar + 1,
			}}
		>
			<Typography color="white" variant="body2" sx={{ fontWeight: 'bold' }}>
				{message}
			</Typography>
		</Box>
	)
}
